import React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp'; // Asegúrate de tener instalado @mui/icons-material
import { tokens } from "../../theme";

const FloatingWhatsAppButton = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16, // Distancia desde la parte inferior
        right: 16, // Distancia desde la parte derecha
        zIndex: 1000, // Asegura que esté sobre otros elementos
      }}
    >
      <IconButton
        aria-label="WhatsApp"
        color="inherit"
        href="https://wa.me/50498000004" // Reemplaza con tu número de WhatsApp
        target="_blank" // Abre en una nueva pestaña
        sx={{
          backgroundColor: colors.greenAccent[500],
          color: colors.softWhiteAccent[500],
          '&:hover': {
            backgroundColor: colors.greenAccent[700],
          },
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)', // Sombra para el botón
          width: 56,
          height: 56, // Tamaño del botón
        }}
      >
        <WhatsAppIcon fontSize="large" />
      </IconButton>
    </Box>
  );
};

export default FloatingWhatsAppButton;